import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Head from "./head/Head";
import { useEffect } from "react";
import Cookies from "js-cookie";

const Layout = ({ title, ...props }) => {
  const navigate = useNavigate()

  const token = Cookies.get("token");
  useEffect(() => {
    if (!token) {
      //navigate("/signin");
    }
  }, []);
  return (
    <>

      <Outlet />

    </>
  );
};
export default Layout;

/*
 <Head title={!title && 'Loading'} />
      <div className="nk-app-root">
        <div className="nk-wrap nk-wrap-nosidebar">
          <div className="nk-content">
            <Outlet />
          </div>
        </div>
      </div>
*/